import * as types from "./types";

const INITIAL_STATE = {
  list: [],
};

const locations = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_LOCATIONS_RESPONSE:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
};

export default locations;
